import React from "react";

/**
 * **********************************************************
 * Dropdown for region values for each winds aloft row
 * **********************************************************
 */
const regionOptions = [
  { value: "bos", label: "Northeast" },
  { value: "mia", label: "Southeast" },
  { value: "chi", label: "Northcentral" },
  { value: "dfw", label: "Southcentral" },
  { value: "slc", label: "Rocky Mtn" },
  { value: "sfo", label: "Pacific Cst" },
];

function ForecastTerminalTable({
  forecastTerminals,
  stationListsByRegion,
  updateForecastTerminalCell,
}) {
  return (
    <div className="navlog-wrapper">
      <p
        style={{
          fontSize: "14px",
          marginBottom: "8px",
          color: "#555",
          textAlign: "left",
        }}
      >
        Load the winds using button above or manually enter forecast terminal data
        in the table below. The forecast terminal fields are used to interpolate
        the winds at the cruise altitude for each navlog row.
      </p>

      <table
        style={{
          width: "100%",
          tableLayout: "fixed",
          marginTop: "12px",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr>
            <th id="navlog-th">Region</th>
            <th id="navlog-th">FT</th>
            <th id="navlog-th" className="alt1-col">Alt1</th>
            <th id="navlog-th" className="alt1-col">Dir1</th>
            <th id="navlog-th" className="alt1-col">Kts1</th>
            <th id="navlog-th" className="alt1-col">°C1</th>
            <th id="navlog-th" className="alt2-col">Alt2</th>
            <th id="navlog-th" className="alt2-col">Dir2</th>
            <th id="navlog-th" className="alt2-col">Kts2</th>
            <th id="navlog-th" className="alt2-col">°C2</th>
            <th id="navlog-th" className="alt3-col">Alt3</th>
            <th id="navlog-th" className="alt3-col">Dir3</th>
            <th id="navlog-th" className="alt3-col">Kts3</th>
            <th id="navlog-th" className="alt3-col">°C3</th>
          </tr>
        </thead>

        <tbody>
          {forecastTerminals.map((ftRow, i) => {
            const rowRegion = ftRow.region || "mia";
            const rowStationList = 
                stationListsByRegion[rowRegion] || [];

            return (
            <tr key={i}>


              <td>
                <select
                  className="navlog-input-region"
                  value={ftRow.region ?? "mia"}
                  onChange={(e) => {
                    updateForecastTerminalCell(i, "region", e.target.value);
                    updateForecastTerminalCell(i, "ft", "");
                  }}
                >
                  {regionOptions.map((region) => (
                    <option
                      key={region.value}
                      value={region.value}
                    >
                      {region.label}
                    </option>
                  ))}
                </select>
              </td>

              <td>
                <select
                  className="navlog-input-ft"
                  value={ftRow.ft ?? ""}
                  onChange={(e) =>
                    updateForecastTerminalCell(
                      i,
                      "ft",
                      e.target.value.toUpperCase()
                    )
                  }
                >
                  <option value="">Select FT</option>

                  {rowStationList.map((code) => (
                    <option key={code} value={code}>
                      {code}
                    </option>
                  ))}
                </select>
              </td>

              <td>
                <input
                  className="navlog-input-alt alt1-col"
                  value={ftRow.alt1}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "alt1", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt1-col"
                  value={ftRow.wd1}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "wd1", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt1-col"
                  value={ftRow.ws1}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "ws1", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt1-col"
                  value={ftRow.t1}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "t1", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt2-col"
                  value={ftRow.alt2}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "alt2", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt2-col"
                  value={ftRow.wd2}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "wd2", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt2-col"
                  value={ftRow.ws2}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "ws2", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt2-col"
                  value={ftRow.t2}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "t2", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt3-col"
                  value={ftRow.alt3}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "alt3", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt3-col"
                  value={ftRow.wd3}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "wd3", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt3-col"
                  value={ftRow.ws3}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "ws3", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="navlog-input-alt alt3-col"
                  value={ftRow.t3}
                  onChange={(e) =>
                    updateForecastTerminalCell(i, "t3", e.target.value)
                  }
                />
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  );
}

export default ForecastTerminalTable;